// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__QyDuE","pagination":"Pagination_pagination__TPu8w","prevArrow":"Pagination_prevArrow__DKEsD","nextArrow":"Pagination_nextArrow__rqD1L"};